import { colors } from "../theme/tokens";

export default function Spinner() {
  return (
    <div style={{ textAlign: "center", padding: "80px 0", color: colors.textFaint }}>
      <div style={{
        fontSize: 32, marginBottom: 12,
        animation: "spin 1s linear infinite",
        display: "inline-block",
      }}>
        ⚙️
      </div>
      <p style={{ fontSize: 13, letterSpacing: 1 }}>Cargando...</p>
    </div>
  );
}
